export { default as Grids } from './grids.container';

export { GridsDetailsContainer as GridDetails } from './gridDetails.component';
